export const TRANSLATIONS = {
  playerWysID: "WysID",
  competition: "Competición",
  competitionSeasonActive: "Competición Activa",
  country: "País",
  endDate: "Fecha Fin",
  fromTeam: "Equipo Origen",
  fromTeamImageURL: "Escudo Origen",
  level: "División",
  playerImageURL: "Foto",
  playerShortName: "Nombre",
  startDate: "Fecha Inicio",
  toTeam: "Equipo Destino",
  toTeamImageURL: "Escudo Destino",
  type: "Tipo",
  cost:"Coste",
  value:"Valor"
};